const DDGuarantee = ({ readyToRead }) => {
  return (
    <section className="container container_narrow ">
      <div className="content_section mt-3">
        <div className="row">
          <div className="col-8 col-md-12" id="left">
            <div className="row">
              <div className="col-8 col-md-9">
                <h2
                  className={`mb-4 greyFont"
                  }`}
                >
                  <span className="blueFont"> The Direct Debit Guarantee</span>
                </h2>
              </div>
              <div className="col-4 col-md-3 oh">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  // width="100"
                  // height="100"
                  viewBox="0 65 200 75"
                >
                  <g fillRule="evenodd">
                    <path fill="#fff" d="M0 0h192.756v192.756H0V0z" />
                    <path d="M91.182 79.879h9.115s9.025-.182 8.934 8.021c-.09 6.108-8.75 7.019-8.75 7.019h-9.298v-15.04h-.001zm27.269 29.445c.256 1.193 1.119 2.508 3.998 2.643 3.828.09 6.016-1.369 6.016-1.369v2.826s-4.193 1.004-6.199 1.004c-2.096 0-8.295-.457-8.295-6.199 0-4.648 5.105-6.107 8.021-6.107 5.105.182 7.566 2.006 7.475 7.201 0 .075-8.399.019-11.016.001zm.012-2.281h6.994s0-2.643-3.373-2.643c-2.537 0-3.367 1.368-3.621 2.643zm22.125-2.854c1.012-1.098 2.711-1.977 5.561-1.977 5.652 0 6.564 4.74 6.473 6.016s-.547 6.107-7.109 6.107c-2.479 0-3.996-.846-4.924-1.896v1.531h-4.467V97.562h4.467v6.627h-.001zm3.83 7.594c2.643-.092 3.828-2.369 3.828-3.463s-.639-3.373-4.012-3.373c-2.617 0-3.414 1.977-3.646 2.943v1.189c.23.985 1.031 2.704 3.83 2.704zm38.559-.455l.09 2.553s-2.096.455-3.463.455-4.924-.82-4.924-4.285v-5.287h-3.736v-2.369h3.736v-2.826h4.559v2.826h3.738v2.369h-3.738v4.559s0 2.279 1.824 2.279c1.822 0 1.914-.274 1.914-.274zM169.121 82.34h5.287v12.67h4.465V82.34h5.379v-2.644h-15.131v2.644zm-1.824.638l.547-2.644s-2.279-1.002-6.289-1.002c-3.92 0-10.209 2.188-10.209 8.113 0 5.834 6.654 7.839 10.756 7.839s5.469-.638 5.469-.638l-.455-2.917s-1.824.547-4.924.547c-3.008-.091-6.105-2.461-6.105-5.104.09-2.37 2.824-5.014 6.381-5.014 2.733 0 4.829.82 4.829.82zm-40.291-3.19s7.475-.364 7.475 4.011c0 3.738-4.283 4.011-4.283 4.011s1.184.182 1.732 1.002c.455.729 3.463 6.199 3.463 6.199h-4.559s-.729-.912-1.094-1.549c-.273-.638-1.094-2.006-1.094-2.006s-.637-2.279-2.826-2.279c-.055 0-.945-.034-1.641-.06v5.894h-4.375V79.788h7.202zm-2.826 6.837h2.371s3.281-.183 3.463-2.188c.092-1.914-3.189-2.188-3.189-2.188h-2.645v4.376zm18.322 2.37h7.293v-2.826h-7.293v-3.464h7.932v-2.917h-12.396v15.223h12.488v-2.735h-8.023v-3.281h-.001zm17.775 11.667h4.467v-3.1h-4.467v3.1zm0 13.309h4.467v-11.576h-4.467v11.576zm-48.675-18.96h4.375V79.788h-4.375v15.223zm-20.42 3.829h9.115s9.025-.184 8.934 8.021c-.09 6.107-8.75 7.02-8.75 7.02h-9.298V98.84h-.001zm4.467 12.215h2.917s6.016-.365 6.016-5.014-6.381-5.105-6.381-5.105h-2.552v10.119zm0-18.961h2.917s6.016-.456 6.016-5.014c0-4.74-6.381-5.104-6.381-5.104h-2.552v10.118zM50.253 88.941v30.5s-17.685-3.191-17.685-15.314c.001-9.669 13.092-13.931 17.685-15.186zm0-.569c-10.629-.769-34.73 4.213-34.73 15.116 0 7.109 12.762 17.502 33.545 17.775.82 0 24.429-.912 24.065-26.253-.306-21.284-16.236-25.012-21.33-25.661v-1.297c20.308 1.289 36.28 13.502 36.28 28.325 0 15.679-17.867 28.44-39.835 28.44S8.504 112.055 8.504 96.377s17.775-28.44 39.744-28.44c.673 0 1.342.012 2.006.036v20.399h-.001z" />
                  </g>
                </svg>
              </div>
            </div>

            <ul
              className={`mb-4 lufga-light DD greyFont "
              }`}
            >
              <li>
                This Guarantee is offered by all banks or building societies
                that accept instructions to pay Direct Debits.
              </li>
              <li>
                If there are any changes to the amount, date or frequency of
                your Direct Debit Lawshield UK Ltd will notify you 2 working days in advance of your
                account being debited or as otherwise agreed. If you request
               Lawshield UK Ltd to collect
                a payment, confirmation of the amount and date will be given to
                you at the time of the request.
              </li>
              <li>
                If an error is made in the payment of your Direct Debit, by
                Lawshield UK Ltd or your
                bank or building society, you are entitled to a full and
                immediate refund of the amount paid from your bank or building
                society.
              </li>
              <li>
                If you receive a refund you are not entitled to, you must pay it
                back when Lawshield UK Ltd
                asks you to.
              </li>
              <li>
                You can cancel a Direct Debit at any time by simply contacting
                your bank or building society. Written confirmation may be
                required. Please also notify us.
              </li>
            </ul>
          </div>
          {/* <div className="col-2 col-sm-2" id="right"></div> */}
        </div>
      </div>
    </section>
  );
};

export default DDGuarantee;
